import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="13" viewBox="0 0 22 13">
    <g fill="none" fillRule="evenodd" stroke="#8F8F8F">
      <path d="M0 6.412L12.901 6.412 20.701 6.412M14.643.353L20.701 6.411 14.643 12.469" transform="matrix(-1 0 0 1 22 0)" />
    </g>
  </svg>
);
